import { z } from 'zod';
export const viewRequestSchema = z.object({
    id: z.string().uuid(),
    budgetId: z.string().uuid(),
    name: z.string(),
    position: z.number(),
    notes: z.string().optional(),
    bucketIds: z.array(z.string().uuid()),
});
export const viewSchema = viewRequestSchema.extend({});
// view sort
export const viewRequestSortSchema = z.object({
    budgetId: z.string().uuid(),
    ids: z.array(z.string().uuid()),
});
// view delete
export const viewDeleteSchema = z.object({
    budgetId: z.string().uuid(),
    id: z.string().uuid(),
});
